<template>
  <div class="whatsappDiv">
    <a href="" @click.prevent="openWhatsapp" class="whatsappDivWrappwe">
      <img src="@/assets/img/services/whatsapp.png" alt="" />
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(["allData"]),
  },
  methods: {
    openWhatsapp() {
      const phoneNo = this.allData?.supportLine || "+2349017775174";
      const url = `whatsapp://send?phone=${phoneNo}&text=${"How may we assist you today?"}`;
      window.open(url);
    },
  },
};
</script>

<style>
</style>